module.exports = __webpack_public_path__ + "img/google-play.e06dab9d.svg";